module.exports = __webpack_public_path__ + "static/Madura-845382c0ff309e13d519e2619ff94f90.jpg";